import { buildAGsPageUrl, buildOfficersPageUrl } from './urlHelpers';

import { OperationType } from '@domain/districts';

export const PRECEDING_URL_LIST = (districtId: string) => [
  `/district/${districtId}/members`,
  `/district/${districtId}/members/officers`,
];

export const getBackUrl = (
  operationType: OperationType | null,
  districtId: string
) => {
  switch (operationType) {
    case OperationType.ASSIGN_TO_ROLE:
    case OperationType.UNASSIGN_ROLE_FROM_OFFICER:
    case OperationType.REPLACE_ROLE:
      return `/district/${districtId}/members`;
    case OperationType.ASSIGN_TO_MEMBER:
    case OperationType.REASSIGN_OFFICER:
    case OperationType.REPLACE_OFFICER:
    case OperationType.REASSIGN_TO_ROLE:
    case OperationType.UNASSIGN_OFFICER_FROM_ROLE:
      return buildOfficersPageUrl(districtId);
    case OperationType.ASSIGN_TO_AG:
    case OperationType.REPLACE_AG:
      return buildAGsPageUrl(districtId);
    default:
      return `/district/${districtId}`;
  }
};
